<div class="notification-history-container">

  <!-- Toggle button at the very top, with stroke below -->
  @if (lastCanceledIndex > 0) {
    <div class="timeline-toggle timeline-toggle-bottom-stroke" (click)="toggleFullHistory()">
      <tidy-text
        [smallHelper]="showFullHistory ? 'Show less' : 'View more history'" />
      <img
        src="assets/svg/chevron-down-white.svg"
        class="toggle-chevron"
        [class.toggle-chevron-up]="!showFullHistory" />
    </div>
  }

  <!-- Hidden/expandable history items (i < lastCanceledIndex) - shown with animation -->
  @if (lastCanceledIndex > 0) {
    <div class="hidden-history" [class.hidden-history-expanded]="showFullHistory">
      @for (item of (items | hideAssignedProDidNotContact: assignedPros); track item; let i = $index) {
        @if (i < lastCanceledIndex) {
          <div class="timeline-item"
               (click)="toggleItem(item)"
               [class.timeline-item-clickable]="item.data.happened && !item.computedIsNewPros">

            <!-- Left column: dot + connecting line -->
            <div class="timeline-left">
              @if (item.computedIconType === 'thinking') {
                <div class="timeline-dot-thinking"></div>
              } @else {
                <div class="timeline-dot-waiting"></div>
              }
              <div class="timeline-line"></div>
            </div>

            <!-- Right column: text content (using helper for expanded items) -->
            <div class="timeline-content">
              <div class="timeline-text-row">
                <tidy-text [helper]="item.text" />
                @if (item['descriptionText']) {
                  <tidy-text [helper]="': ' + item['descriptionText']" />
                }
                @if (item.data.type === 'contacted' && item.data.happened && !item.computedIsNewPros) {
                  <tidy-text [helper]="': contacted'" />
                }
                @if (item.data.type === 'contacted' && item.computedIsNewPros && (item.data.resolved_at || !isSearchingForPro)) {
                  <tidy-text [helper]="': contacted'" />
                }
                @if (item.data.type === 'contacted' && isSearchingForPro && (!item.data.happened || (item.computedIsNewPros && !item.data.resolved_at))) {
                  <tidy-text [helper]="': contacting'" />
                }
                @if (item.data.type === 'not_contacted') {
                  <tidy-text [helper]="': skipped'" />
                }
                @if (item.data.type === 'did_not_contact') {
                  <tidy-text [helper]="': not contacted'" />
                }
                @if (item.data.type === 'declined') {
                  @if (item.computedIsNewPros && hasQuotes) {
                    <tidy-text [helper]="': contacted'" />
                  } @else {
                    <tidy-text [helper]="': declined'" />
                  }
                }
                @if (item.data.type === 'accepted') {
                  <tidy-text [helper]="': accepted'" />
                }
                @if (item.data.type === 'canceled') {
                  <tidy-text [helper]="': cancelled'" />
                }
              </div>

              @if (item.computedActionDate && item.data.happened && (!item.computedIsNewPros || item.data.resolved_at)) {
                <div class="timeline-time">
                  <tidy-text [smallHelper]="item.computedActionDate" />
                </div>
              }

              @if (isSearchingForPro && item.data.happened && item.data.type !== 'declined' && item.computedIsNewPros && !item.data.resolved_at) {
                <div class="timeline-cycling-status"
                     [class.timeline-cycling-visible]="statusTextVisible"
                     [class.timeline-cycling-hidden]="!statusTextVisible">
                  <tidy-text [smallHelper]="'<i>' + currentStatusText + '</i>'" />
                </div>
              }

              @if (item.expanded) {
                <div class="notification-history-expanded-step">
                  @if (isLoadingNotificationHistory) {
                    <tidy-loader />
                  } @else {
                    @if (item?.data?.type === 'canceled' && item?.data?.cancellation_reason) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/svg/information-circle-outline.svg'" />
                        <tidy-text
                          [helper]="item.text + (' had to cancel because ' | translate) + item.data.cancellation_reason" />
                      </tidy-row>
                    }
                    @if (item?.data?.type === 'not_contacted' && item.computedNotContactedReason) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/svg/information-circle-outline.svg'" />
                        <tidy-text
                          [helper]="item.text + ' ' + item.computedNotContactedReason" />
                      </tidy-row>
                    }
                    @if (item?.data?.type === 'did_not_contact') {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/svg/information-circle-outline.svg'" />
                        <tidy-text
                          [helper]="item.text + (' was not contacted because another pro was assigned to this job.' | translate)" />
                      </tidy-row>
                    }
                    @if (notificationHistory?.decline_reason) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/svg/information-circle-outline.svg'" />
                        <tidy-text
                          [helper]="('Decline reason: ' | translate) + notificationHistory?.decline_reason" />
                      </tidy-row>
                    }
                    @if (item?.data?.type === 'declined' && item.computedDeclinedAtAbsolute) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/svg/calendar-outline.svg'" />
                        <tidy-text
                          [helper]="('Declined on: ' | translate) + item.computedDeclinedAtAbsolute" />
                      </tidy-row>
                    }
                    @if (item.computedContactedDateAbsolute && item?.data?.type !== 'not_contacted' && item?.data?.type !== 'canceled') {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/svg/calendar-outline.svg'" />
                        <tidy-text
                          [helper]="('Contacted on: ' | translate) + item.computedContactedDateAbsolute" />
                      </tidy-row>
                    }
                    @if (item?.data?.type === 'accepted' && item.computedAcceptedDateAbsolute) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/svg/calendar-outline.svg'" />
                        <tidy-text
                          [helper]="('Accepted on: ' | translate) + item.computedAcceptedDateAbsolute" />
                      </tidy-row>
                    }
                    @if (item?.data?.type === 'canceled' && item.computedCanceledDateAbsolute) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="'assets/svg/calendar-outline.svg'" />
                        <tidy-text
                          [helper]="('Canceled on: ' | translate) + item.computedCanceledDateAbsolute" />
                      </tidy-row>
                    }
                    @if (!item.computedIsNewPros) {
                      @if (item?.data?.homekeeper_id) {
                        <tidy-row class="vertical-align-middle">
                          <tidy-image
                            [src]="'assets/svg/person-circle-outline.svg'" />
                          <tidy-text
                            class="white-link"
                            [body]="'View Pro'"
                            (action)="viewPro(item?.data?.homekeeper_id)" />
                        </tidy-row>
                      }
                      @if (notificationHistory?.notifications) {
                        @if (notificationHistory?.notifications?.app) {
                          <tidy-row class="vertical-align-middle">
                            <tidy-image
                              [src]="notificationHistory?.notifications?.app?.status === 'sent' ? 'assets/svg/checkmark-circle-outline.svg' : 'assets/svg/alert-circle-outline.svg'" />
                            <tidy-text
                              [helper]="notificationHistory?.notifications?.app?.status === 'sent' ? 'Notified in app' : 'In-app notifications not set up'" />
                            <span>&nbsp;</span>
                            @if (notificationHistory?.notifications?.app?.status === 'sent') {
                              <tidy-text
                                class="white-link"
                                [body]="'Details'"
                                (action)="viewHistory(notificationHistory, 'app')" />
                            }
                          </tidy-row>
                        }
                        @if (notificationHistory?.notifications?.sms) {
                          <tidy-row class="vertical-align-middle">
                            <tidy-image
                              [src]="notificationHistory?.notifications?.sms?.status === 'queued' ? 'assets/svg/checkmark-circle-outline.svg' : 'assets/svg/alert-circle-outline.svg'" />
                            <tidy-text
                              [helper]="notificationHistory?.notifications?.sms?.status === 'queued' ? 'Notified via sms' : 'Failed to notify via sms'" />
                            <span>&nbsp;</span>
                            @if (notificationHistory?.notifications?.sms?.status === 'queued') {
                              <tidy-text
                                class="white-link"
                                [body]="'Details'"
                                (action)="viewHistory(notificationHistory, 'sms')" />
                            }
                          </tidy-row>
                        }
                        @if (notificationHistory?.notifications?.email) {
                          <tidy-row class="vertical-align-middle">
                            <tidy-image
                              [src]="notificationHistory?.notifications?.email?.status === 'OK' ? 'assets/svg/checkmark-circle-outline.svg' : 'assets/svg/alert-circle-outline.svg'" />
                            <tidy-text
                              [helper]="notificationHistory?.notifications?.email?.status === 'OK' ? 'Notified via email' : 'Failed to notify via email'" />
                            <span>&nbsp;</span>
                            @if (notificationHistory?.notifications?.email?.status === 'OK') {
                              <tidy-text
                                class="white-link"
                                [body]="'Details'"
                                (action)="viewHistory(notificationHistory, 'email')" />
                            }
                          </tidy-row>
                        }
                      }
                    }
                  }
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  }

  <!-- Always-visible items (from lastCanceledIndex onward) -->
  @for (item of (items | hideAssignedProDidNotContact: assignedPros); track item; let i = $index; let last = $last) {
    @if (lastCanceledIndex === -1 || i >= lastCanceledIndex) {
      <div class="timeline-item"
           (click)="toggleItem(item)"
           [class.timeline-item-clickable]="item.data.happened && !item.computedIsNewPros">

        <!-- Left column: dot + connecting line -->
        <div class="timeline-left">
          @if (item.computedIconType === 'thinking') {
            <div class="timeline-dot-thinking"></div>
          } @else {
            <div class="timeline-dot-waiting"></div>
          }
          @if (!last) {
            <div class="timeline-line"></div>
          }
        </div>

        <!-- Right column: text content -->
        <div class="timeline-content">
          <div class="timeline-text-row">
            @if (item.data.happened && !item.computedIsNewPros) {
              <tidy-text [clickableBody]="item.text" />
            } @else {
              <tidy-text [body]="item.text" />
            }
            @if (item['descriptionText']) {
              <tidy-text [body]="': ' + item['descriptionText']" />
            }
            @if (item.data.type === 'contacted' && item.data.happened && !item.computedIsNewPros) {
              <tidy-text [body]="': contacted'" />
            }
            @if (item.data.type === 'contacted' && item.computedIsNewPros && (item.data.resolved_at || !isSearchingForPro)) {
              <tidy-text [body]="': contacted'" />
            }
            @if (item.data.type === 'contacted' && isSearchingForPro && (!item.data.happened || (item.computedIsNewPros && !item.data.resolved_at))) {
              <tidy-text [body]="': contacting'" />
            }
            @if (item.data.type === 'not_contacted') {
              <tidy-text [body]="': skipped'" />
            }
            @if (item.data.type === 'did_not_contact') {
              <tidy-text [body]="': not contacted'" />
            }
            @if (item.data.type === 'declined') {
              @if (item.computedIsNewPros && hasQuotes) {
                <tidy-text [body]="': contacted'" />
              } @else {
                <tidy-text [body]="': declined'" />
              }
            }
            @if (item.data.type === 'accepted') {
              <tidy-text [body]="': accepted'" />
            }
            @if (item.data.type === 'canceled') {
              <tidy-text [body]="': cancelled'" />
            }
          </div>

          @if (item.computedActionDate && item.data.happened && (!item.computedIsNewPros || item.data.resolved_at)) {
            <div class="timeline-time">
              <tidy-text [smallHelper]="item.computedActionDate" />
            </div>
          }

          @if (isSearchingForPro && item.data.happened && item.data.type !== 'declined' && item.computedIsNewPros && !item.data.resolved_at) {
            <div class="timeline-cycling-status"
                 [class.timeline-cycling-visible]="statusTextVisible"
                 [class.timeline-cycling-hidden]="!statusTextVisible">
              <tidy-text [smallHelper]="'<i>' + currentStatusText + '</i>'" />
            </div>
          }

          @if (item.expanded) {
            <div class="notification-history-expanded-step">
              @if (isLoadingNotificationHistory) {
                <tidy-loader />
              } @else {
                @if (item?.data?.type === 'canceled' && item?.data?.cancellation_reason) {
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/svg/information-circle-outline.svg'" />
                    <tidy-text
                      [helper]="item.text + (' had to cancel because ' | translate) + item.data.cancellation_reason" />
                  </tidy-row>
                }
                @if (item?.data?.type === 'not_contacted' && item.computedNotContactedReason) {
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/svg/information-circle-outline.svg'" />
                    <tidy-text
                      [helper]="item.text + ' ' + item.computedNotContactedReason" />
                  </tidy-row>
                }
                @if (item?.data?.type === 'did_not_contact') {
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/svg/information-circle-outline.svg'" />
                    <tidy-text
                      [helper]="item.text + (' was not contacted because another pro was assigned to this job.' | translate)" />
                  </tidy-row>
                }
                @if (notificationHistory?.decline_reason) {
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/svg/information-circle-outline.svg'" />
                    <tidy-text
                      [helper]="('Decline reason: ' | translate) + notificationHistory?.decline_reason" />
                  </tidy-row>
                }
                @if (item?.data?.type === 'declined' && item.computedDeclinedAtAbsolute) {
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/svg/calendar-outline.svg'" />
                    <tidy-text
                      [helper]="('Declined on: ' | translate) + item.computedDeclinedAtAbsolute" />
                  </tidy-row>
                }
                @if (item.computedContactedDateAbsolute && item?.data?.type !== 'not_contacted' && item?.data?.type !== 'canceled') {
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/svg/calendar-outline.svg'" />
                    <tidy-text
                      [helper]="('Contacted on: ' | translate) + item.computedContactedDateAbsolute" />
                  </tidy-row>
                }
                @if (item?.data?.type === 'accepted' && item.computedAcceptedDateAbsolute) {
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/svg/calendar-outline.svg'" />
                    <tidy-text
                      [helper]="('Accepted on: ' | translate) + item.computedAcceptedDateAbsolute" />
                  </tidy-row>
                }
                @if (item?.data?.type === 'canceled' && item.computedCanceledDateAbsolute) {
                  <tidy-row class="vertical-align-middle">
                    <tidy-image
                      [src]="'assets/svg/calendar-outline.svg'" />
                    <tidy-text
                      [helper]="('Canceled on: ' | translate) + item.computedCanceledDateAbsolute" />
                  </tidy-row>
                }
                @if (!item.computedIsNewPros) {
                  @if (item?.data?.homekeeper_id) {
                    <tidy-row class="vertical-align-middle">
                      <tidy-image
                        [src]="'assets/svg/person-circle-outline.svg'" />
                      <tidy-text
                        class="white-link"
                        [body]="'View Pro'"
                        (action)="viewPro(item?.data?.homekeeper_id)" />
                    </tidy-row>
                  }
                  @if (notificationHistory?.notifications) {
                    @if (notificationHistory?.notifications?.app) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="notificationHistory?.notifications?.app?.status === 'sent' ? 'assets/svg/checkmark-circle-outline.svg' : 'assets/svg/alert-circle-outline.svg'" />
                        <tidy-text
                          [helper]="notificationHistory?.notifications?.app?.status === 'sent' ? 'Notified in app' : 'In-app notifications not set up'" />
                        <span>&nbsp;</span>
                        @if (notificationHistory?.notifications?.app?.status === 'sent') {
                          <tidy-text
                            class="white-link"
                            [body]="'Details'"
                            (action)="viewHistory(notificationHistory, 'app')" />
                        }
                      </tidy-row>
                    }
                    @if (notificationHistory?.notifications?.sms) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="notificationHistory?.notifications?.sms?.status === 'queued' ? 'assets/svg/checkmark-circle-outline.svg' : 'assets/svg/alert-circle-outline.svg'" />
                        <tidy-text
                          [helper]="notificationHistory?.notifications?.sms?.status === 'queued' ? 'Notified via sms' : 'Failed to notify via sms'" />
                        <span>&nbsp;</span>
                        @if (notificationHistory?.notifications?.sms?.status === 'queued') {
                          <tidy-text
                            class="white-link"
                            [body]="'Details'"
                            (action)="viewHistory(notificationHistory, 'sms')" />
                        }
                      </tidy-row>
                    }
                    @if (notificationHistory?.notifications?.email) {
                      <tidy-row class="vertical-align-middle">
                        <tidy-image
                          [src]="notificationHistory?.notifications?.email?.status === 'OK' ? 'assets/svg/checkmark-circle-outline.svg' : 'assets/svg/alert-circle-outline.svg'" />
                        <tidy-text
                          [helper]="notificationHistory?.notifications?.email?.status === 'OK' ? 'Notified via email' : 'Failed to notify via email'" />
                        <span>&nbsp;</span>
                        @if (notificationHistory?.notifications?.email?.status === 'OK') {
                          <tidy-text
                            class="white-link"
                            [body]="'Details'"
                            (action)="viewHistory(notificationHistory, 'email')" />
                        }
                      </tidy-row>
                    }
                  }
                }
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>
